const packages = [
  {
    name: 'Starter',
    price: '$149',
    per: 'per video',
    description: 'Perfect for creators just getting started with short-form content.',
    features: [
      '1 short-form video (up to 60 sec)',
      'Basic cuts & transitions',
      'Music layover (licensed)',
      'Captions & subtitles',
      '1 round of revisions',
      '48-hour delivery',
    ],
    highlight: false,
    cta: 'Get Started',
  },
  {
    name: 'Growth',
    price: '$349',
    per: 'per month',
    description: 'Ideal for brands posting consistently and growing their audience.',
    features: [
      '4 short-form videos/month',
      'Advanced cuts & transitions',
      'Music layover + voiceover sync',
      'Animated captions',
      'Color grading',
      '2 rounds of revisions each',
      '48-hour delivery',
    ],
    highlight: true,
    cta: 'Most Popular',
  },
  {
    name: 'Pro',
    price: '$649',
    per: 'per month',
    description: 'For businesses and creators who need high-volume, premium content.',
    features: [
      '10 short-form videos/month',
      'Full motion graphics & text',
      'Music + voiceover + sound design',
      'Animated captions & lower thirds',
      'Cinematic color grading',
      'Unlimited revisions',
      '24-hour priority delivery',
    ],
    highlight: false,
    cta: 'Go Pro',
  },
];

export default function Packages() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#1E3A8A]/10 text-[#1E3A8A] text-xs font-semibold rounded-full mb-4 tracking-widest uppercase">
            Pricing
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Transparent, Flat-Rate Pricing</h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base leading-relaxed">
            No hidden fees. No surprises. Pick the plan that fits your content schedule and budget.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-stretch">
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              className={`rounded-2xl p-8 flex flex-col ${
                pkg.highlight
                  ? 'bg-[#1E3A8A] text-white shadow-2xl scale-105'
                  : 'bg-gray-50 text-gray-900 shadow-sm'
              }`}
            >
              <div className="mb-6">
                <h3 className={`text-xl font-bold mb-1 ${pkg.highlight ? 'text-white' : 'text-gray-900'}`}>
                  {pkg.name}
                </h3>
                <p className={`text-sm mb-4 ${pkg.highlight ? 'text-blue-200' : 'text-gray-500'}`}>
                  {pkg.description}
                </p>
                <div className="flex items-end gap-1">
                  <span className={`text-4xl font-bold ${pkg.highlight ? 'text-white' : 'text-gray-900'}`}>
                    {pkg.price}
                  </span>
                  <span className={`text-sm mb-1 ${pkg.highlight ? 'text-blue-200' : 'text-gray-500'}`}>
                    {pkg.per}
                  </span>
                </div>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {pkg.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3">
                    <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 ${pkg.highlight ? '' : ''}`}>
                      <i className={`ri-check-line text-sm font-bold ${pkg.highlight ? 'text-blue-200' : 'text-[#1E3A8A]'}`}></i>
                    </div>
                    <span className={`text-sm ${pkg.highlight ? 'text-blue-100' : 'text-gray-600'}`}>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`block text-center py-3 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  pkg.highlight
                    ? 'bg-white text-[#1E3A8A] hover:bg-blue-50'
                    : 'bg-[#1E3A8A] text-white hover:bg-[#1E3A8A]/90'
                }`}
              >
                {pkg.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
